import React from 'react';
import { Translation } from 'react-i18next';
import Logger from '../../../../../lib/Logger';
import { Typography, Input, Checkbox } from 'antd';
import LearningModuleCategoryList from '../../learnings/containers/LearningModuleCategoryListContainer';

const { Title } = Typography;

const optionStates = [
  {
    label: 'Not Started',
    value: 'not_started',
  },
  {
    label: 'In Progress',
    value: 'progress',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
];

const LearningModuleFilters = ({
  selectedTags,
  setSelectedTags,
  onSearch,
  setState,
  ...props
}) => {
  const onChangeState = (checkedValues) => {
    setState(checkedValues);
  };

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            borderRadius: '10px',
            backgroundColor: '#fbfbfb',
            padding: '20px',
          }}
        >
          <Title level={3}>{t('learning_module_series_filter_title')}</Title>
          <Input
            placeholder={t('learning_module_series_filter_search')}
            onChange={(e) => onSearch(e)}
            allowClear
          />
          <br />
          <br />
          <Title level={4}>
            {t('learning_module_series_filter_title_categories')}
          </Title>
          <LearningModuleCategoryList
            selectedTags={selectedTags}
            setSelectedTags={setSelectedTags}
          />
          <br />
          <Title level={4}>
            {t('learning_module_series_filter_title_type')}
          </Title>

          <Checkbox.Group
            options={optionStates}
            onChange={onChangeState}
            className='checkbox-group-two-columns'
          />
        </div>
      )}
    </Translation>
  );
};

export default LearningModuleFilters;

Logger.log('silly', `LearningModuleFilters loaded.`);
